import {Helmet} from "react-helmet";
import {RouteInfo} from "../../route/RouteHelper";
import RaikoDefaultDialogPage, {DialogSize} from "../../component/defaultDialogPage/RaikoDefaultDialogPage";
import AddNews from "../../component/addNews/AddNews";
import {css} from "@emotion/css";
import RaikoBreadcrumb, {
    raikoBreadCrumbItemGenerator
} from "../../raikoComponents/raikoBreadcrumbCustom/RaikoBreadcrumb";
import RaikoBaseCardContainer from "../../raikoComponents/raikoBaseCardContainer/RaikoBaseCardContainer";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import RaikoCustomTable from "../../raikoComponents/raikoCustomTable/RaikoCustomTable";
import {useEffect, useState} from "react";
import {SpecialNewsService} from "./SpecialNewsService";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useSnackbar} from "notistack";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import {convertUniversalDateToPersianDate} from "../../util/DateConvertor";
import {RaikoCustomSimpleChip} from "../../raikoComponents/raikoCustomChip/raikoCustomSimpleChip/RaikoCustomSimpleChip";
import {RaikoChipTypes} from "../../raikoComponents/raikoCustomChip/RaikoChipTypes";
import ButtonDivisionSection from "../../component/ButtonDivisionSection/ButtonDivisionSection";
import ButtonSimpleIcon from "../../raikoComponents/raikoButtons/ButtonSimpleIcon";
import SpecialNewsAddNewItem from "../../component/specialNews/SpecialNewsAddNewItem";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import RaikoCustomSimpleActiveDeActiveChip
    from "../../raikoComponents/raikoCustomChip/raikoCustomSimpleActiveDeactiveChip/RaikoCustomSimpleActiveDeActiveChip";
import {useNavigate} from "react-router-dom";

export default function SpecialNews() {

    let page = 0
    const size = 15

    const service = new SpecialNewsService();
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())


    useEffect(() => {
        if (typeof service !== 'undefined') {
            getDataFromServer()
        }
    }, []);


    function prepareTableItems(id, number, title, publishedDate, creator, publishState, link) {
        return {
            id,
            number,
            title,
            creator,
            publishedDate: convertUniversalDateToPersianDate(publishedDate),
            publishState: <RaikoCustomSimpleActiveDeActiveChip state={publishState} activeStateTitle={"منتشر شده"}
                                                               deActiveStateTitle={"منتشر نشده"}/>,
            access: <div className={css`display: flex;
              flex-wrap: nowrap;
              justify-content: center;
              align-items: center;`}>
                <ButtonSimpleIcon iconClass={"share-link-icon"}/>
                {/*<ButtonSimpleIcon iconClass={"delete-icon"}/>*/}
            </div>
        };
    }

    const [tableList, setTableList] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);

    const [addNewsDialogOpenState, setAddNewsDialogOpenState] = useState(false);

    function closeAddNewsDialog() {
        setAddNewsDialogOpenState(false)
    }

    function openAddNewsDialog() {
        setAddNewsDialogOpenState(true)
    }

    function handlePagination(newPage) {
        page = newPage
        getDataFromServer()
    }

    function getDataFromServer() {
        setTableLoading(true)

        service.getSpecialNewsList(page, size)
            .then(response => {
                 setPageCount(response.totalPage)
                 setTableList([])
                 response.data.map((item, index) => {
                     setTableList(prevState => [
                         ...prevState,
                         prepareTableItems(
                             item.id,
                             (page * size) + index + 1,
                             item.title,
                             item.createdAt,
                             item.createdBy,
                             item.published,
                             ""
                         )
                     ])
                 })
                setTableLoading(false)
            }).catch(reason => {
            setTableLoading(false)
            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در دریافت لیست خبر هssssای ویژه"))
        })
    }

    const navigate = useNavigate()

    function handleShowDetail(itemId) {
        navigate(RouteInfo.SpecialNewsDetail.globalUrl.replace(":id", itemId))
    }

    return (
        <>
            <Helmet>
                <title>{RouteInfo.NewsList.name}</title>
            </Helmet>

            <RaikoDefaultDialogPage
                dialogSize={DialogSize.WRAP_CONTENT}
                onClose={closeAddNewsDialog}
                open={addNewsDialogOpenState}
                pageTitle={"افزودن"}
            >
                <SpecialNewsAddNewItem
                    handleCloseDialog={closeAddNewsDialog}
                    handleAddNewItem={response => {
                        if (page === 0) {
                            if (tableList.length > 0) {
                                const _items = tableList
                                setTableList([])
                                _items.map((item, index) => {
                                    if (index === 0) {
                                        setTableList([
                                            prepareTableItems(
                                                response.id,
                                                1,
                                                response.title,
                                                response.createdAt,
                                                response.createdBy,
                                                false,
                                                response.link
                                            )
                                        ])
                                    }

                                    setTableList(prevState => [
                                        ...prevState,
                                        {
                                            ...item,
                                            number: (page * size) + index + 2
                                        }
                                    ])
                                })
                            } else {
                                setTableList([
                                    prepareTableItems(
                                        response.id,
                                        1,
                                        response.title,
                                        response.createdAt,
                                        response.createdBy,
                                        false,
                                        response.link
                                    )
                                ])
                            }
                        }
                    }}
                />

            </RaikoDefaultDialogPage>


            <section
                className={css`
                  padding: 26px 0;
                  overflow: hidden;
                `}>

                <RaikoBreadcrumb
                    breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(
                            "مقالات",
                            ""
                        ),
                        raikoBreadCrumbItemGenerator(
                            "اخبار ويژه",
                            RouteInfo.SpecialNewsList.globalUrl
                        ),
                    ]}
                />

                <RaikoBaseCardContainer
                    className={`${css`
                      margin-top: 40px;
                    `}`}>


                    <ButtonDivisionSection>
                        <ButtonPrimaryRaiko
                            label={"افزودن"}
                            className={css`
                              height: max-content !important;
                            `}
                            onClick={openAddNewsDialog}
                        />
                    </ButtonDivisionSection>

                    <div className={css`
                      width: 100%;
                      margin-top: 1rem;
                      overflow-x: scroll !important;
                    `}>
                        <RaikoCustomTable
                            data={tableList}
                            header={columns}
                            isLoading={tableLoading}
                            pageCount={pageCount}
                            handlePaginationChange={handlePagination}
                            rowClicked={handleShowDetail}
                        />
                    </div>


                </RaikoBaseCardContainer>

            </section>
        </>
    )
}

const columns = [
    {
        id: 'number',
        label: '#'
    }, {
        id: 'title',
        label: 'عنوان'
    }, {
        id: 'publishedDate',
        label: 'تاریخ ساخت'
    }, {
        id: 'creator',
        label: 'سازنده',
    },
    /*{
        id: 'access',
        label: 'دسترسی ها',
    },*/
    {
        id: 'publishState',
        label: 'وضعیت انتشار',
    },
];